export default __webpack_public_path__ + "static/media/kitchen3-afterF-768w.c54ac9e2.webp";